import type { SVGProps } from 'react';
import * as React from 'react';

const SvgBack2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={props.className ? `rtl:-scale-x-100 ${props.className}` : 'rtl:-scale-x-100'}
  >
    <path d="M16 22 6 12 16 2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgBack2;
